import type { CollectionCardAlign } from '@/lib/blocks/collection/blocks';
import { readIndexCollectionLayoutKey } from '@/lib/blocks/collection/index-collection/blocks';
import type { PageBlock } from '@/types/block';

/** Section layout keys for index collection cards (grid, list, split). */
export type IndexCollectionLayout = 'grid' | 'list' | 'split';

export function readIndexCollectionLayout(
  block: Pick<PageBlock, 'props'> & { indexCollectionLayoutKey?: string },
): IndexCollectionLayout {
  const key = readIndexCollectionLayoutKey(block);
  if (key === 'grid') return 'grid';
  if (key === 'list') return 'list';
  if (key === 'split') return 'split';

  throw new Error(`Unsupported index collection layout: ${key ?? 'missing'}`);
}

export function contentAlignClassName(align: CollectionCardAlign, stretch = false) {
  if (align === 'center') return 'items-center text-center';
  if (align === 'end') return 'items-end text-right';
  return stretch ? 'items-stretch text-left' : 'items-start text-left';
}
